import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "ResetEnrolmentsConfirmationModal"
}
const _hoisted_2 = { class: "ConfirmationModalContent" }
const _hoisted_3 = { class: "ConfirmationModalText" }
const _hoisted_4 = { class: "ConfirmationModalCount" }
const _hoisted_5 = { class: "ConfirmationModalButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "ConfirmationModalHeader" }, [
      _createElementVNode("h3", { class: "ConfirmationModalTitle" }, "Reset enrolments")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode(" Are you sure you want to reset ")),
        _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.selectedEnrolmentsCount), 1 /* TEXT */),
        _cache[3] || (_cache[3] = _createTextVNode(" enrolment")),
        (_ctx.selectedEnrolmentsCount !== 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("s")
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _cache[4] || (_cache[4] = _createTextVNode("? "))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "ConfirmationModalButtonNo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
        }, "No"),
        _createElementVNode("button", {
          class: "DriverButton ConfirmationModalButtonYes",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm()))
        }, "Yes")
      ])
    ])
  ], 512 /* NEED_PATCH */))
}